import { render, staticRenderFns } from "./TicketMenuItem.vue?vue&type=template&id=724a29b0&scoped=true&"
import script from "./TicketMenuItem.vue?vue&type=script&lang=js&"
export * from "./TicketMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./TicketMenuItem.vue?vue&type=style&index=0&id=724a29b0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724a29b0",
  null
  
)

export default component.exports